<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: "App",
  };
</script>

<style lang="scss">
  @import "./assets/_scss/main";

  #app {
    background: #f4f6f8;
    -webkit-overflow-scrolling: touch; /* Use momentum scrolling in iOS Safari */
    min-height: 100%;
    font-family: "Open Sans", Helvetica, Arial, sans-serif;
    font-size: 14px;
  }
</style>
